var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPresent2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 10v4.8H2.4V10h4.8zm6.4 0v4.8H8.8V10h4.8zM7.2 6v2.4H1.6V6h5.6zm7.2 2.4H8.8V6h5.6v2.4zM8.8 2v.849L9.6 2h1.13v1.132l-.44.469h.51l.8.8-.8.8H5.2l-.8-.8.8-.8h.51l-.441-.47V2h1.13l.8.849V2L8 1.2l.8.8z",
    fill: "#00B67D"
  })));
}

export default SvgPresent2Icon;